import { render } from "./ExpandableBadge.vue?vue&type=template&id=66184f28&scoped=true&ts=true"
import script from "./ExpandableBadge.vue?vue&type=script&lang=ts"
export * from "./ExpandableBadge.vue?vue&type=script&lang=ts"

import "./ExpandableBadge.vue?vue&type=style&index=0&id=66184f28&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66184f28"]])

export default __exports__